export * from './get-static-paths'
export { StoryblokRenderer } from './renderer'
export {
  StoryblokRenderer as StoryblokRendererV2,
  type ComponentLayouts,
} from './renderer-v2'
